import { AnnouncementsList } from '~/features/announcements/announcements-list'
import { EAnnouncementType } from '~/features/announcements/types'

export const SiteAnnouncements = () => (
  <AnnouncementsList
    detailPageBaseRoute="/announcement"
    tagId={EAnnouncementType.LiveTag}
    documentTitle="公告"
    pageTitle="直播公告"
  />
)
